module.exports = __webpack_public_path__ + "static/media/5.0ce0d1dc.jpg";